import React from "react";
import "./font.css"

const About = () => {
	return (
		<div class="styled-font">
			<h1>
                PNW Runs is a place for runners wanting to connect 
				to running communities in the Pacific Northwest!
			</h1>
		</div>
	);
};

export default About;